export const APP_INIT = 'APP_INIT';
export const APP_SHUTDOWN = 'APP_SHUTDOWN';
export const PAY_WITH_ETH_FEE_UPDATED = 'PAY_WITH_ETH_FEE_UPDATED';
export const PAY_WITH_ETH_FEE_UPDATE_FAILED = 'PAY_WITH_ETH_FEE_UPDATE_FAILED';
export const PAY_WITH_CAT_FEE_UPDATED = 'PAY_WITH_CAT_FEE_UPDATED';
export const PAY_WITH_CAT_FEE_UPDATE_FAILED = 'PAY_WITH_CAT_FEE_UPDATE_FAILED';
export const LATEST_BLOCK_NUMBER_UPDATED = 'LATEST_BLOCK_NUMBER_UPDATED';
export const LATEST_BLOCK_NUMBER_UPDATE_FAILED = 'LATEST_BLOCK_NUMBER_UPDATE_FAILED';
export const ACCOUNT_TOS_ACCEPT = 'ACCOUNT_TOS_ACCEPT';
export const ACCOUNT_INTRO_COMPLETE = 'ACCOUNT_INTRO_COMPLETE';
export const ACCOUNT_WALLET_RESET = 'ACCOUNT_WALLET_RESET';
export const ACCOUNT_WALLET_SELECT = 'ACCOUNT_WALLET_SELECT';
export const ACCOUNT_NOT_PROVIDED = 'ACCOUNT_NOT_PROVIDED';
export const ACCOUNT_REFRESHING = 'ACCOUNT_REFRESHING';
export const ACCOUNT_CHANGE = 'ACCOUNT_CHANGE';
export const ACCOUNT_CHANGE_FAILED = 'ACCOUNT_CHANGE_FAILED';
export const ACCOUNT_BALANCE_UPDATE = 'ACCOUNT_BALANCE_UPDATE';
export const ACCOUNT_BALANCE_UPDATE_FAILED = 'ACCOUNT_BALANCE_UPDATE_FAILED';
export const CAT_BALANCE_UPDATE = 'CAT_BALANCE_UPDATE';
export const CAT_BALANCE_UPDATE_FAILED = 'CAT_BALANCE_UPDATE_FAILED';
export const CAT_ALLOWANCE_UPDATE = 'CAT_ALLOWANCE_UPDATE';
export const CAT_ALLOWANCE_UPDATE_FAILED = 'CAT_ALLOWANCE_UPDATE_FAILED';
export const CAT_AUTHORIZATION_START = 'CAT_AUTHORIZATION_START';
export const CAT_AUTHORIZATION_ABORTED = 'CAT_AUTHORIZATION_ABORTED';
export const CAT_AUTHORIZATION_SUBMITTED = 'CAT_AUTHORIZATION_SUBMITTED';
export const CAT_AUTHORIZATION_FAILED = 'CAT_AUTHORIZATION_FAILED';
export const CAT_AUTHORIZATION_CONFIRMED = 'CAT_AUTHORIZATION_CONFIRMED';
export const CAT_AUTHORIZATION_REJECTED = 'CAT_AUTHORIZATION_REJECTED';
export const ACCOUNT_NETWORK_CHANGE = 'ACCOUNT_NETWORK_CHANGE';
export const ACCOUNT_NETWORK_CHANGE_FAILED = 'ACCOUNT_NETWORK_CHANGE_FAILED';
export const ETH_CURRENCY_EXCHANGE_RATES_FETCHED = 'ETH_CURRENCY_EXCHANGE_RATES_FETCHED';
export const ETH_CURRENCY_EXCHANGE_RATES_FETCH_FAILED = 'ETH_CURRENCY_EXCHANGE_RATES_FETCH_FAILED';
export const ETH_CURRENCY_EXCHANGE_RATES_LOCAL_LOADED = 'ETH_CURRENCY_EXCHANGE_RATES_LOCAL_LOADED';
export const CAT_ETH_EXCHANGE_RATE_FETCHED = 'CAT_ETH_EXCHANGE_RATE_FETCHED';
export const CAT_ETH_EXCHANGE_RATE_FETCH_FAILED = 'CAT_ETH_EXCHANGE_RATE_FETCH_FAILED';
export const CAT_ETH_EXCHANGE_RATE_LOCAL_LOADED = 'CAT_ETH_EXCHANGE_RATE_LOCAL_LOADED';
export const CURRENCY_CODE_CHANGE = 'CURRENCY_CODE_CHANGE';
export const CURRENCY_CODE_LOCAL_LOADED = 'CURRENCY_CODE_LOCAL_LOADED';
export const PAYMENTS_FETCHED = 'PAYMENTS_FETCHED';
export const PAYMENTS_FETCH_FAILED = 'PAYMENTS_FETCH_FAILED';
export const PAYMENT_EVENTS_FETCHED = 'PAYMENT_EVENTS_FETCHED';
export const PAYMENT_EVENTS_FETCH_FAILED = 'PAYMENT_EVENTS_FETCH_FAILED';
export const PAYMENT_SEND_START = 'PAYMENT_SEND_START';
export const PAYMENT_SEND_ABORTED = 'PAYMENT_SEND_ABORTED';
export const PAYMENT_SEND_SUBMITTED = 'PAYMENT_SEND_SUBMITTED';
export const PAYMENT_SEND_FAILED = 'PAYMENT_SEND_FAILED';
export const PAYMENT_SEND_CONFIRMED = 'PAYMENT_SEND_CONFIRMED';
export const PAYMENT_SEND_REJECTED = 'PAYMENT_SEND_REJECTED';
export const PAYMENT_ACCEPT_START = 'PAYMENT_ACCEPT_START';
export const PAYMENT_ACCEPT_ABORTED = 'PAYMENT_ACCEPT_ABORTED';
export const PAYMENT_ACCEPT_SUBMITTED = 'PAYMENT_ACCEPT_SUBMITTED';
export const PAYMENT_ACCEPT_FAILED = 'PAYMENT_ACCEPT_FAILED';
export const PAYMENT_ACCEPT_CONFIRMED = 'PAYMENT_ACCEPT_CONFIRMED';
export const PAYMENT_ACCEPT_REJECTED = 'PAYMENT_ACCEPT_REJECTED';
export const PAYMENT_CANCEL_START = 'PAYMENT_CANCEL_START';
export const PAYMENT_CANCEL_ABORTED = 'PAYMENT_CANCEL_ABORTED';
export const PAYMENT_CANCEL_SUBMITTED = 'PAYMENT_CANCEL_SUBMITTED';
export const PAYMENT_CANCEL_FAILED = 'PAYMENT_CANCEL_FAILED';
export const PAYMENT_CANCEL_CONFIRMED = 'PAYMENT_CANCEL_CONFIRMED';
export const PAYMENT_CANCEL_REJECTED = 'PAYMENT_CANCEL_REJECTED';
export const PAYMENT_LOCALLY_DISCARDED = 'PAYMENT_LOCALLY_DISCARDED';
export const PAYMENT_LOCALLY_DISCARD_FAILED = 'PAYMENT_LOCALLY_DISCARD_FAILED';
export const PAYMENT_DISMISSED = 'PAYMENT_DISMISSED';
export const PAYMENT_PENDING = 'PAYMENT_PENDING';
export const PAYEMNT_PENDING_FAILED = 'PAYEMNT_PENDING_FAILED';
export const PAYMENTS_LOCAL_LOADED = 'PAYMENTS_LOCAL_LOADED';
export const RECOMMENDED_GAS_PRICES_UPDATE = 'RECOMMENDED_GAS_PRICE_UPDATE';
export const RECOMMENDED_GAS_PRICES_UPDATE_FAILED = 'RECOMMENDED_GAS_PRICE_UPDATE_FAILED';
export const TOKENS_LOCAL_LOADED = 'TOKENS_LOCAL_LOADED';
export const CUSTOM_TOKEN_ADDED = 'CUSTOM_TOKEN_ADDED';
export const TOKEN_ADDRESS_CHANGE = 'TOKEN_ADDRESS_CHANGE';
export const TOKEN_BALANCE_UPDATE = 'TOKEN_BALANCE_UPDATE';
export const TOKEN_BALANCE_UPDATE_FAILED = 'TOKEN_BALANCE_UPDATE_FAILED';
export const TOKEN_ALLOWANCE_UPDATE = 'TOKEN_ALLOWANCE_UPDATE';
export const TOKEN_ALLOWANCE_UPDATE_FAILED = 'TOKEN_ALLOWANCE_UPDATE_FAILED';
export const TOKEN_INFO_UPDATE = 'TOKEN_INFO_UPDATE';
export const TOKEN_INFO_UPDATE_FAILED = 'TOKEN_INFO_UPDATE_FAILED';
export const TOKEN_AUTHORIZATION_START = 'TOKEN_AUTHORIZATION_START';
export const TOKEN_AUTHORIZATION_ABORTED = 'TOKEN_AUTHORIZATION_ABORTED';
export const TOKEN_AUTHORIZATION_SUBMITTED = 'TOKEN_AUTHORIZATION_SUBMITTED';
export const TOKEN_AUTHORIZATION_FAILED = 'TOKEN_AUTHORIZATION_FAILED';
export const TOKEN_AUTHORIZATION_CONFIRMED = 'TOKEN_AUTHORIZATION_CONFIRMED';
export const TOKEN_AUTHORIZATION_REJECTED = 'TOKEN_AUTHORIZATION_REJECTED';
export const TRANSACTION_RECEIPTS_FETCHED = 'TRANSACTION_RECEIPTS_FETCHED';
export const TRANSACTION_RECEIPTS_FETCH_FAILED = 'TRANSACTION_RECEIPTS_FETCH_FAILED';
export const TRANSACTION_DISCARD_LOCAL = 'TRANSACTION_DISCARD_LOCAL';
export const ACCOUNT_WALLET_RELOAD_STARTED = 'ACCOUNT_WALLET_RELOAD_STARTED';
export const ACCOUNT_WALLET_RELOAD_FAILED = 'ACCOUNT_WALLET_RELOAD_FAILED';
export const ACCOUNT_WALLET_RELOAD_COMPLETED = 'ACCOUNT_WALLET_RELOAD_COMPLETED';



// WEBPACK FOOTER //
// ./src/actionTypes.js